export default __webpack_public_path__ + "static/media/3669_124687.3dc455db.svg";